var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6364 15.1258V10.9094C28.6364 9.47964 27.5274 8.31688 26.1263 8.20413L22.2106 1.36475C21.8477 0.732208 21.2617 0.280106 20.5606 0.0923746C19.8628 -0.0940783 19.1331 0.00384627 18.5085 0.367356L5.08528 8.18214H2.72774C1.22365 8.18214 0.000488281 9.40524 0.000488281 10.9094V27.2728C0.000488281 28.7768 1.22359 30 2.72774 30H25.9092C27.4133 30 28.6364 28.7769 28.6364 27.2728V23.0563C29.4283 22.7739 30 22.0242 30 21.1365V17.0457C30 16.1579 29.4283 15.4082 28.6364 15.1258ZM24.5418 8.18214H18.5991L23.0562 5.58727L24.5418 8.18214ZM22.3787 4.40393L15.889 8.18214H13.1972L21.7056 3.22839L22.3787 4.40393ZM19.195 1.54584C19.5033 1.36539 19.8634 1.31745 20.2077 1.40937C20.5559 1.50256 20.8463 1.72762 21.0267 2.04256L21.0281 2.04505L10.4872 8.18214H7.79546L19.195 1.54584ZM27.2728 27.2728C27.2728 28.0245 26.6609 28.6364 25.9092 28.6364H2.72774C1.97605 28.6364 1.36414 28.0245 1.36414 27.2728V10.9094C1.36414 10.1577 1.97605 9.5458 2.72774 9.5458H25.9092C26.6609 9.5458 27.2728 10.1577 27.2728 10.9094V15.0002H23.1819C20.9261 15.0002 19.0911 16.8352 19.0911 19.0911C19.0911 21.3469 20.9261 23.1819 23.1819 23.1819H27.2728V27.2728ZM28.6364 21.1365C28.6364 21.5127 28.3309 21.8183 27.9546 21.8183H23.1819C21.6779 21.8183 20.4547 20.5952 20.4547 19.0911C20.4547 17.587 21.6778 16.3638 23.1819 16.3638H27.9546C28.3308 16.3638 28.6364 16.6694 28.6364 17.0457V21.1365Z",
    fill: "#0D1444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.182 17.7275C22.4303 17.7275 21.8184 18.3394 21.8184 19.0911C21.8184 19.8428 22.4303 20.4547 23.182 20.4547C23.9336 20.4547 24.5455 19.8428 24.5455 19.0911C24.5456 18.3394 23.9337 17.7275 23.182 17.7275Z",
    fill: "#0D1444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.89e2700bec6250b61f94c1011c2a918e.svg";
export { ForwardRef as ReactComponent };